import script from "./DialogDashboardPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogDashboardPopup.vue?vue&type=script&setup=true&lang=js"

import "./DialogDashboardPopup.vue?vue&type=style&index=0&id=0e97bd1c&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e97bd1c"]])

export default __exports__